module.exports = __webpack_public_path__ + "img/bng1.b056e320.png";